// Lightweight dev-only logger. In production these calls are no-ops.
const isDev = process.env.NODE_ENV !== "production";

export const log = {
  error: (...args) => { if (isDev) console.error(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
};
